<template>
  <v-row class="px-2">
    <v-col cols="12" sm="12" md="12" style="font-size: 15px" class="text-center justify-md-end font-weight-bold">
      Информация о сроках внесения в систему поставок и статусов сотрудников
      <template>
        {{ filters.region.name }}
      </template>
      (
      <template>
        {{ startFilterDisplayValue }}
      </template>
      -
      <template>
        {{ endFilterDisplayValue }}
      </template>)
    </v-col>
    <v-col cols="12" sm="6" md="3" class="d-print-none d-print-none">
      <v-select v-model="filters.region"
                :items="$store.getters.appLogin.regions"
                :item-value="item => item"
                :item-text="item => item.name"
                label="Область"
                :clearable="false"
                @change="sortedPostIndexes()"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" class="d-print-none">
      <v-autocomplete v-model="filters.postIndex"
                      :items="sortedPostIndexes()"
                      :item-value="item => item.postCode"
                      :item-text="item => `${item.postCode} - ${item.name}`"
                      label="Пост индекс"
                      :clearable="true"

      />
    </v-col>
    <v-col cols="12" md="3" class="d-print-none">
      <v-menu
          v-model="filterStartMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Начало пероида"
              v-model="startFilterDisplayValue"
              readonly

              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.start"
            @change="onFilterStartChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.$store.getters.appLogin.id === 1 || this.$store.getters.appLogin.id === 10 || this.$store.getters.appLogin.id === 11  || this.$store.getters.appLogin.id === 44) {
                return true;
              }
              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7)&&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="3" class="d-print-none">
      <v-menu
          v-model="filterEndMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Конец пероида"
              v-model="endFilterDisplayValue"
              readonly

              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.end"
            @change="onFilterEndChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7) &&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="10" class="d-flex justify-left  justify-md-start d-print-none">
      <v-checkbox
          v-model="filters.isAllClientsSelected"
          color="primary"
          :label="`Выбрать все организации`"
      ></v-checkbox>
    </v-col>
    <v-col cols="12" sm="6" md="2" class="d-print-none justify-md-end d-flex ">
      <v-btn v-if="this.$store.getters.appLogin.id === 1" large color="warning" class="me-2" dark @click="onExcelButtonClicked">Загрузить в Excel</v-btn>
      <v-btn :disabled="disableRefreshButton" class="primary" @click="onRefreshClicked" large>Обновить</v-btn>
      <v-btn  @click="onPrintClicked" color="primary" class="ml-2" large>Распечатать</v-btn>
    </v-col>
    <v-col cols="12" md="12" sm="12" class="mx-auto" style="width: 100%;">
      <v-simple-table dense style="width: 100%;">
        <template v-slot:default>
          <thead>
          <tr>
            <th rowspan="2" style="width: 5px; background-color: aliceblue">№</th>
            <th rowspan="2" style="background-color: aliceblue">
              <v-text-field
                v-model="searchTerm"
                label="Имя"
                rounded
                append-icon="mdi-magnify"

              ></v-text-field>
            </th>
            <th rowspan="2" style="background-color: aliceblue" class="text-center filter-header">Тип аккаунта</th>
            <th rowspan="2" style="background-color: aliceblue" class="text-center filter-header">Названия отделения</th>
            <th colspan="3" @click="toggleFilter(1)" style="background-color: aliceblue" class="text-center filter-header">Доставлен</th>
            <th colspan="3" @click="toggleFilter(2)" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }" class="text-center filter-header">Возврат</th>
            <th colspan="3" @click="toggleFilter(3)" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }" class="text-center filter-header">Ввод информация систему</th>
          </tr>
          <tr>
            <th class="text-center filter-header" style="background-color: aliceblue">Срок</th>
            <th class="text-center filter-header" style="background-color: aliceblue">Просрочка</th>
            <th class="text-center filter-header" style="background-color: aliceblue">Итого</th>
            <th class="text-center filter-header" @click="toggleFilter(2)" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">Срок</th>
            <th class="text-center filter-header" @click="toggleFilter(2)" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">Просрочка</th>
            <th class="text-center filter-header" @click="toggleFilter(2)" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">Итого</th>
            <th class="text-center filter-header" @click="toggleFilter(3)" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">Срок</th>
            <th class="text-center filter-header" @click="toggleFilter(3)" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">Просрочка</th>
            <th class="text-center filter-header" @click="toggleFilter(3)" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">Итого</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in getItems()" :key="item.AccountName + index">
            <td>
              {{ index + 1 }}
            </td>
            <td>{{ item.AccountName }}</td>
            <td>{{ getAccountType(item.AccountType) }}</td>
            <td>{{ item.PostIndexCode }}</td>
            <td>{{ item.DeliveredBeforeTime }}</td>
            <td>{{ item.DeliveredAfterTime }}</td>
            <td>{{ item.DeliveredCount }}</td>
            <td :style="{ backgroundColor: !filters.selectedFilters.includes(2) ? '#e5e5e5' : '' }">{{ filters.selectedFilters.includes(2) ? item.ReturnedBeforeTime : null }}</td>
            <td :style="{ backgroundColor: !filters.selectedFilters.includes(2) ? '#e5e5e5' : '' }">{{ filters.selectedFilters.includes(2) ? item.ReturnedAfterTime : null }}</td>
            <td :style="{ backgroundColor: !filters.selectedFilters.includes(2) ? '#e5e5e5' : '' }">{{ filters.selectedFilters.includes(2) ? item.ReturnedCount : null }}</td>
            <td :style="{ backgroundColor: !filters.selectedFilters.includes(3) ? '#e5e5e5' : '' }">{{ filters.selectedFilters.includes(3) ? item.BeforeTimeEnteredInformation : null }}</td>
            <td :style="{ backgroundColor: !filters.selectedFilters.includes(3) ? '#e5e5e5' : '' }">{{ filters.selectedFilters.includes(3) ? item.AfterTimeEnteredInformation : null }}</td>
            <td :style="{ backgroundColor: !filters.selectedFilters.includes(3) ? '#e5e5e5' : '' }">{{ filters.selectedFilters.includes(3) ? item.EnteredInformationCount : null }}</td>
          </tr>
          <tr style="background-color: aliceblue; color: black; font-weight: bold">
            <td style="background-color: aliceblue"></td>
            <td style="background-color: aliceblue">Общее</td>
            <td style="background-color: aliceblue"></td>
            <td style="background-color: aliceblue"></td>
            <td style="background-color: aliceblue">{{ totals.DeliveredBeforeTime }}</td>
            <td style="background-color: aliceblue">{{ totals.DeliveredAfterTime }}</td>
            <td style="background-color: aliceblue">{{ totals.DeliveredCount }}</td>
            <td :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ totals.ReturnedBeforeTime }}</td>
            <td :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ totals.ReturnedAfterTime }}</td>
            <td :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ totals.ReturnedCount }}</td>
            <td :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ totals.BeforeTimeEnteredInformation }}</td>
            <td :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ totals.AfterTimeEnteredInformation }}</td>
            <td :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ totals.EnteredInformationCount }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import $store from "@/store";
import region from "../../../domain/Region";
import {DateLimitForFilters} from "@/settings/server";
import {
  Admin,
  GlobalAdmin,
  PostOfficeAreaOperator,
  PostOfficeOperator,
  PostOfficeRegionAdmin, Shipox
} from "@/enums/account.type";

export default {
  name: "UsersReport",
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      searchTerm: "",
      filters: {
        start: null,
        end: null,
        region: this.$store.getters.appRegions[0],
        date: null,
        selectedFilters: [],
        postIndex: null,
        isAllClientsSelected: false
      },
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,
      dateFilterDisplayValue: null,
      filterDateMenu: false,
    }
  },
  methods: {
    toggleFilter(filterId) {
      const index = this.filters.selectedFilters.findIndex(id => id === filterId);
      if (index !== -1) {
        this.filters.selectedFilters.splice(index, 1);
      } else {
        this.filters.selectedFilters.push(filterId);
      }
    },
    getAccountType(type){
      switch (type){
        case 0: return PostOfficeAreaOperator.name;
        case 1: return Admin.name;
        case 3: return PostOfficeOperator.name;
        case 4: return PostOfficeRegionAdmin.name;
        case 6: return Shipox.name;
        case 100: return GlobalAdmin.name;
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }

      return false;
    },
    getItems(){
      let sortedItems = [];
      let items = [];
      if(this.searchTerm !== null){
        items = this.items.filter((item) =>
            item.AccountName.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      }
      else {
        items = this.items;
      }

      for (const item of items) {
        let total = this.total(item);
        if (total > 0) {
          sortedItems.push(item);
        }
      }
      return sortedItems;
    },
    total(item){
      let count = 0;
      if(item.DeliveredBeforeTime){
        count += item.DeliveredBeforeTime
      }
      if(item.DeliveredAfterTime){
        count += item.DeliveredAfterTime
      }
      if(item.DeliveredCount){
        count += item.DeliveredCount
      }
      if(item.ReturnedBeforeTime){
        count += item.ReturnedBeforeTime
      }
      if(item.ReturnedCount){
        count += item.ReturnedCount
      }
      if(item.ReturnedAfterTime){
        count += item.ReturnedAfterTime
      }
      if(item.BeforeTimeEnteredInformation){
        count += item.BeforeTimeEnteredInformation
      }
      if(item.AfterTimeEnteredInformation){
        count += item.AfterTimeEnteredInformation
      }
      if(item.EnteredInformationCount){
        count += item.EnteredInformationCount
      }
      return count;
    },
    onPrintClicked() {
      window.print()
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      this.updateItems()
    },
    onExcelButtonClicked() {
      this.$emit('onExcel')
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },
    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    sortedPostIndexes(){
      var selectedRegionId = this.filters.region?.id
      if(selectedRegionId > 0){
        return $store.getters.appPostIndexes.filter(item => item.postRegionCode === selectedRegionId)
      }
      else{
        return $store.getters.appPostIndexes;
      }
    }
  },
  computed: {
    region() {
      return region
    },
    totals() {
      let PrintedForPeriodResult = 0;
      let DeliveredBeforeTime = 0;
      let DeliveredAfterTime = 0;
      let DeliveredCount = 0;
      let ReturnedBeforeTime = 0;
      let ReturnedAfterTime = 0;
      let ReturnedCount = 0;
      let BeforeTimeEnteredInformation = 0;
      let AfterTimeEnteredInformation = 0;
      let EnteredInformationCount = 0;

      _.each(this.items, item => {
        PrintedForPeriodResult += item.PrintedForPeriodResult
        if(item.DeliveredBeforeTime !== null){
          DeliveredBeforeTime += item.DeliveredBeforeTime
        }
        if(item.DeliveredAfterTime !== null){
          DeliveredAfterTime += item.DeliveredAfterTime
        }
        if(item.DeliveredCount !== null){
          DeliveredCount += item.DeliveredCount
        }
        if(item.ReturnedBeforeTime !== null){
          ReturnedBeforeTime += item.ReturnedBeforeTime
        }
        if(item.ReturnedAfterTime !== null){
          ReturnedAfterTime += item.ReturnedAfterTime
        }
        if(item.ReturnedCount !== null){
          ReturnedCount += item.ReturnedCount
        }
        if(item.BeforeTimeEnteredInformation !== null){
          BeforeTimeEnteredInformation += item.BeforeTimeEnteredInformation
        }
        if(item.AfterTimeEnteredInformation !== null){
          AfterTimeEnteredInformation += item.AfterTimeEnteredInformation
        }
        if(item.EnteredInformationCount !== null){
          EnteredInformationCount += item.EnteredInformationCount
        }
      });
      return {
        PrintedForPeriodResult,
        DeliveredBeforeTime,
        DeliveredAfterTime,
        DeliveredCount,
        ReturnedBeforeTime,
        ReturnedAfterTime,
        ReturnedCount,
        BeforeTimeEnteredInformation,
        AfterTimeEnteredInformation,
        EnteredInformationCount
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload()
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.filters.start = Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.end = Moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')

    this.updateItems()
  }
}
</script>

<style scoped>
.filter-header {
  padding: 10px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.filter-header:hover{
  background-color: #dfe7ed;
}
@media print {
  .table-container {
    overflow: visible !important;
    width: 100%;
  }
}

.table-scroll thead th {
  padding: 0 5px 0 5px;
}

th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>
